/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { dummyWorkaround } from '../fn/dummy-workaround/dummy-workaround';
import { DummyWorkaround$Params } from '../fn/dummy-workaround/dummy-workaround';

@Injectable({ providedIn: 'root' })
export class DummyWorkaroundService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dummyWorkaround()` */
  static readonly DummyWorkaroundPath = '/dummy/workaround';

  /**
   * Workaround to generate model objects not user in apis.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dummyWorkaround()` instead.
   *
   * This method doesn't expect any request body.
   */
  dummyWorkaround$Response(params: DummyWorkaround$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return dummyWorkaround(this.http, this.rootUrl, params, context);
  }

  /**
   * Workaround to generate model objects not user in apis.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dummyWorkaround$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dummyWorkaround(params: DummyWorkaround$Params, context?: HttpContext): Observable<void> {
    return this.dummyWorkaround$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
